import {
  DEFAULT_NAMESPACE,
  type MasonryEngineNode,
  type MasonryEngineNodeQueryParams,
} from '@leagueplatform/masonry-engine';
import { GET_MASONRY_NODE_ENDPOINT } from '../../constants/masonry-node-api';

type GetMasonryRootNodeParams = {
  id: MasonryEngineNode['id'];
  initialQueryParams?: MasonryEngineNodeQueryParams;
};

export const createAsyncNode = ({
  id,
  initialQueryParams,
}: GetMasonryRootNodeParams): MasonryEngineNode => ({
  id,
  type: 'containerSpinner', // Replace this with spinner renderer
  properties: {},
  sections: {},
  namespace: DEFAULT_NAMESPACE,
  asyncConfig: {
    getterParams: {
      id,
      pathname: `${GET_MASONRY_NODE_ENDPOINT}${id}`,
      method: 'GET',
    },
    initialQueryParams,
  },
});
